import { defineAsyncComponent } from 'vue';
import { config } from '@/config';

export default {
	description: "Складской учет",
	access: {
		read: true,
		create: true,
		update: true,
		delete: ['admin'] 
	},
	fields: {
		items: {
			description: "Позиции накладной",
			depends: "id",
			type: {
				table: {
					key: "id",
					ownerField: "nakladnye_id",
					description: "Позиции накладной",
					fields: {
						id: { description: "id", type: "UUID" },
						nakladnye_id: { description: "Накладная", type: { reference: "nakladnye" } },
						position_number: { description: "№ п/п", type: "INTEGER" },
						product_name: { description: "Наименование товара", type: "TEXT"},
						group: {
							description: "Группа",
							type: { reference: "product_groups" }
						},
						funding_source: {
							description: "Источник финансирования",
							type: { reference: "funding_sources" }
						},
						unit: { description: "Единица измерения", type: "STRING" },
						quantity: { description: "Количество", type: "DECIMAL" },
						price: { description: "Цена", type: "DECIMAL" },
						cost: { description: "Стоимость", type: "DECIMAL" },
						vat_rate: { description: "Ставка НДС (%)", type: "DECIMAL" },
						vat_amount: { description: "Сумма НДС", type: "DECIMAL" },
						cost_with_vat: { description: "Стоимость с НДС", type: "DECIMAL" },
						departure_point: { description: "Пункт отправления", type: "STRING" },
						destination_point: { description: "Пункт назначения", type: "STRING" },
						ettn_number: { description: "Номер ЭТТН", type: "STRING" },
						price_with_vat: { description: "Цена с НДС", type: "DECIMAL" },
						quantity_main_unit: { description: "Количество в основной единице", type: "DECIMAL" },
						price_without_vat: { description: "Цена без НДС", type: "DECIMAL" },
						quantity_additional_unit: { description: "Количество в дополнительной единице", type: "DECIMAL" },
						markup: { description: "Наценка/надбавка", type: "DECIMAL" },
						kpr: { description: "Код продукта", type: "STRING" },
						imn: { description: "Наименование товара", type: "STRING" },
						imeu: { description: "Единица измерения", type: "STRING" },
						ctp: { description: "Страна происхождения", type: "STRING" },
						vidtov: { description: "Вид товара", type: "STRING" },
						torg: { description: "Торговое наименование", type: "STRING" },
						ctro: { description: "Количество основное", type: "DECIMAL" },
						nacoo: { description: "Наценка общая", type: "DECIMAL" },
						nacol: { description: "Наценка общая (лист)", type: "DECIMAL" },
						nac: { description: "Наценка", type: "DECIMAL" },
						nds: { description: "НДС", type: "DECIMAL" },
						ctr: { description: "Количество", type: "DECIMAL" },
						ctov: { description: "Количество товара", type: "DECIMAL" },
						kol: { description: "Количество", type: "DECIMAL" },
						spar: { description: "Поставщик", type: "STRING" },
						okpo: { description: "ОКПО", type: "STRING" },
						unn: { description: "УНН", type: "STRING" },
						kodn: { description: "Код накладной", type: "STRING" },
						di: { description: "Дополнительная информация", type: "STRING" },
						di2: { description: "Дополнительная информация 2", type: "STRING" },
						oc: { description: "Особые условия", type: "BOOLEAN" },
						code: { description: "Код", type: "STRING" },
						preysk: { description: "Прейскурант", type: "STRING" },
						fgrlevel1: { description: "Уровень классификации 1", type: "STRING" },
						fgrlevel2: { description: "Уровень классификации 2", type: "STRING" },
						fgrlevel3: { description: "Уровень классификации 3", type: "STRING" },
						fgrlevel4: { description: "Уровень классификации 4", type: "STRING" },
						tnved: { description: "ТН ВЭД", type: "STRING" },
						lekform: { description: "Лекарственная форма", type: "STRING" },
						vidlekform: { description: "Вид лекарственной формы", type: "STRING" },
						spishr: { description: "Срок годности", type: "STRING" },
						dsv: { description: "Документ сертификации", type: "STRING" },
						datattn: { description: "Дата ТТН", type: "STRING" },
						sopr_doc: { description: "Сопроводительный документ", type: "STRING" },
						vid_post: { description: "Вид поставки", type: "STRING" },
						pmn: { description: "ПМН", type: "INTEGER" },
						prizcenalg: { description: "Признак ценовой алгебры", type: "INTEGER" },
						sd1: { description: "СД1", type: "INTEGER" },
						kolpr: { description: "Количество прирост", type: "DECIMAL" },
						edizmpr: { description: "Единица измерения прирост", type: "STRING" },
						vidup: { description: "Вид упаковки", type: "STRING" },
						kolup: { description: "Количество упаковки", type: "DECIMAL" },
						edizmup: { description: "Единица измерения упаковки", type: "STRING" },
						ctrb: { description: "Количество руб", type: "DECIMAL" },
						koldv1: { description: "Количество дополнительное 1", type: "DECIMAL" },
						edizm1: { description: "Единица измерения 1", type: "STRING" },
						pimp: { description: "Пункт импорта", type: "STRING" },
						otd: { description: "Отдел", type: "INTEGER" },
						imp: { description: "Импорт", type: "STRING" },
						imf: { description: "ИМФ", type: "STRING" },
						ims: { description: "ИМС", type: "STRING" },
						created_at: { description: "Время создания", type: "DATE" },
						updated_at: { description: "Время изменения", type: "DATE" }
					}
				}
			}
		}
	},
	forms: {
		list: {
			component: defineAsyncComponent(() => import('./forms/List.vue')),
			config: {
				fields: {
					name: {},
					lasteditor: {},
					description: {
						config: {
							width: '350px'
						}
					},
					created_at: {
						config: {
							width: '150px'
						}
					}
				}
			},
		},
		edit: {
			panel: {
				height: '450px',
				width: '60%'
			},
			component: defineAsyncComponent(() => import('./forms/Edit.vue'))
		}
	}
}
